import { ActionButtons, Footer, SectionPlaceholder } from "@ucl/library";
import { TaskExecutionModuleProps } from "@bolt/task";
import { BoltDocumentTemplatePreview } from "../components/BoltDocumentTemplatePreview/BoltDocumentTemplatePreview";

interface DocumentTemplateTaskExecutionTypeFieldSchema {
  DocumentTemplateTaskExecutionType__DocumentTemplateId: string;
}

export const DocumentTemplateTaskExecutionTypeModule: React.FC<
  TaskExecutionModuleProps
> = (props) => {
  if (!props.entityId || !props.entityType) {
    return (
      <SectionPlaceholder label="Document Template Task could not be loaded." />
    );
  }

  const value =
    props.taskExecutionTypeFields as unknown as DocumentTemplateTaskExecutionTypeFieldSchema;

  return (
    <div className="document-template-task-execution-type-module">
      <BoltDocumentTemplatePreview
        documentTemplateId={
          value.DocumentTemplateTaskExecutionType__DocumentTemplateId
        }
        modelName={props.entityType}
        modelId={props.entityId}
      />
      <Footer>
        {!props.isReadOnly ? (
          <ActionButtons
            actions={[
              {
                text: "Complete",
                isPrimary: true,
                onActionClick: () => {
                  props.onTaskComplete?.(props.taskExecutionTypeFields);
                },
              },
            ]}
          />
        ) : (
          <></>
        )}
      </Footer>
    </div>
  );
};
